<template>
  <div class="counter">
    <InputField
      v-model="inputValue"
      class="counter__field"
      :color="color"
      :type="inputType"
      :placeholder="placeholder"
      :description="description"
      :label="label"
      :mark="mark"
      :readonly="readonly"
      :error="error"
      @input="val => onInputValue(val)"
    >
      <button v-if="!readonly" class="button-reset counter__button" type="button" @click="decrement">
        <Minus :stroke-width="2.5" />
      </button>

      <button v-if="!readonly" class="button-reset counter__button" type="button" @click="increment">
        <Plus :stroke-width="2.5" />
      </button>
    </InputField>
  </div>
</template>

<script>
import InputField from '@/components/form/Input.vue'
import debounce from 'lodash/debounce'
import { Minus, Plus } from 'lucide-vue'

export default {
  name: 'Counter',
  components: {
    InputField,
    Minus,
    Plus,
  },
  props: {
    value: Number,
    placeholder: String,
    min: { type: Number, default: 1 },
    max: { type: Number, default: 1000000000000 },
    step: { type: Number, default: 10 },
    /**
     * The style of the counter
     * @values white, gray
     */
    color: { type: String, default: 'white' },
    description: String,
    label: String,
    mark: String,
    readonly: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      inputValue: this.value || this.min || 0,
      inputType: 'number',
    }
  },
  watch: {
    value: {
      handler() {
        this.inputValue = this.value
      },
      immediate: true,
    },
  },
  methods: {
    increment() {
      this.onChangeValue(this.inputValue + this.step)
    },
    decrement() {
      this.onChangeValue(this.inputValue - this.step)
    },
    onChangeValue(val) {
      val = Number(val)

      if (val > this.max) {
        val = this.max
      } else if (val < this.min) {
        val = this.min
      }

      this.inputValue = val
      this.$emit('input', val)
    },
    onInputValue: debounce(function (...args) {
      this.onChangeValue(args)
    }, 1000),
  },
}
</script>

<style lang="scss" scoped>
@import '~bootstrap/scss/functions';
@import '@/assets/scss/config';
@import '@/assets/scss/mixins';
@import '~bootstrap/scss/variables';
@import '~bootstrap/scss/mixins';

.counter {
  display: flex;
  align-items: center;
  position: relative;

  .counter__button {
    cursor: pointer;
    display: block;
    height: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:not(:last-child) {
      margin-right: 6px;
    }

    > svg {
      width: 16px;
      height: 16px;
    }

    &:active {
      opacity: 0.85;
    }
  }

  .counter__field {
    width: 100%;
  }
}
</style>
